import api from './api';

export interface Template {
  id: number;
  title: string;
  content: string;
  type: 'contrato' | 'email' | 'sms' | 'termos' | 'recibo';
  termo_adesao?: string | null;
  rescisao_contrato?: string | null;
  variables?: string[];
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface TemplateCreateData {
  title: string;
  content: string;
  type: 'contrato' | 'email' | 'sms' | 'termos' | 'recibo';
  termo_adesao?: string | null;
  rescisao_contrato?: string | null;
  variables?: string[];
  isActive?: boolean;
}

export interface TemplateUpdateData {
  title?: string;
  content?: string;
  type?: 'contrato' | 'email' | 'sms' | 'termos' | 'recibo';
  termo_adesao?: string | null;
  rescisao_contrato?: string | null;
  variables?: string[];
  isActive?: boolean;
}

export interface TemplateListResponse {
  templates: Template[];
  totalItems: number;
  totalPages: number;
  currentPage: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export interface TemplateFilters {
  type?: string;
  isActive?: boolean;
  search?: string;
  page?: number;
  limit?: number;
}

export interface VariablesResponse {
  variables: string[];
}

class TemplateService {
  async getTemplates(filters: TemplateFilters = {}): Promise<TemplateListResponse> {
    const params = new URLSearchParams();
    
    if (filters.type) params.append('type', filters.type);
    if (filters.isActive !== undefined) params.append('isActive', filters.isActive.toString());
    if (filters.search) params.append('search', filters.search);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    
    const url = `/templates?${params.toString()}`;
    
    try {
      // O interceptor retorna response.data diretamente
      const response: any = await api.get(url);
      return response;
    } catch (error) {
      console.error('🚨 Erro na requisição:', error);
      throw error;
    }
  }

  async getTemplateById(id: number): Promise<Template> {
    const response: any = await api.get(`/templates/${id}`);
    return response;
  }

  async createTemplate(data: TemplateCreateData): Promise<Template> {
    const response: any = await api.post('/templates', data);
    return response;
  }

  async updateTemplate(id: number, data: TemplateUpdateData): Promise<Template> {
    const response: any = await api.put(`/templates/${id}`, data);
    return response;
  }

  async deleteTemplate(id: number): Promise<void> {
    await api.delete(`/templates/${id}`);
  }

  async toggleTemplateStatus(id: number): Promise<Template> {
    const response: any = await api.patch(`/templates/${id}/toggle`);
    return response;
  }

  async getAvailableVariables(type: string): Promise<VariablesResponse> {
    const response: any = await api.get(`/templates/variables/${type}`);
    return response;
  }
}

const templateService = new TemplateService();
export default templateService; 